import React from 'react';
import MessageSequence from './MessageSequence';
import { TypedMap } from 'flow/types/TypedMap';
import { Message } from 'flow/types/Chats';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import MessageGroupDivider from './MessageGroupDivider';

export interface GroupedMessageProps {
    date: string;
    messages: TypedMap<Message>[];
}

const MessageGroup = ({
    group,
    sessionKey,
    showContextMenu = true,
}: {
    group: GroupedMessageProps;
    sessionKey: ChatSessionKey;
    showContextMenu?: boolean;
}) => {
    return (
        <div className="w-full max-w-2xl" key={group.date}>
            <MessageGroupDivider date={group.date} />

            <div className="relative">
                <MessageSequence
                    messages={group.messages}
                    sessionKey={sessionKey}
                    showContextMenu={showContextMenu}
                />
            </div>
        </div>
    );
};

export default MessageGroup;
